import React, { useState, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Typography, Box } from '@material-ui/core'
import AdminPage from '../../../admin/shared/AdminPage'
import { useGetAiSkills } from '../../../../../api/denaliAssistant'
import SkillList from './SkillList'
import SkillForm from './SkillForm'
import SkillVersionHistory from './SkillVersionHistory'

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  twoColumnLayout: {
    display: 'grid',
    gridTemplateColumns: '30% 70%',
    gap: theme.spacing(2),
    height: '100%',
    minHeight: 0
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden'
  },
  leftColumn: {
    borderRight: '1px solid var(--color-neutral-300)',
    paddingRight: theme.spacing(2)
  },
  rightColumn: {
    // Edit column
  }
}))

function DenaliAISkills ({ root }) {
  const classes = useStyles()
  const [selectedSkillId, setSelectedSkillId] = useState(null)
  const [isNewSkill, setIsNewSkill] = useState(false)

  const { data: skillsData, isLoading: isLoadingSkills } = useGetAiSkills({
    allVersions: false,
    includeAll: true,
    skip: 0,
    take: 1000
  })

  const skills = useMemo(() => skillsData?.skills || [], [skillsData?.skills])

  const handleSelectNew = useCallback(() => {
    setIsNewSkill(true)
    setSelectedSkillId(null)
  }, [])

  const handleSelectSkill = useCallback((skillId) => {
    if (selectedSkillId === skillId) return
    setIsNewSkill(false)
    setSelectedSkillId(skillId)
  }, [selectedSkillId])

  return (
    <AdminPage>
      <div className={classes.container}>
        <div className={classes.twoColumnLayout}>
          {/* Left Column - Skill List */}
          <div className={`${classes.column} ${classes.leftColumn}`}>
            <SkillList
              skills={skills}
              selectedSkillId={selectedSkillId}
              isNewSelected={isNewSkill}
              onSelectNew={handleSelectNew}
              onSelectSkill={handleSelectSkill}
              isLoading={isLoadingSkills}
            />
          </div>

          {/* Right Column - Version History & Form */}
          <div className={`${classes.column} ${classes.rightColumn}`}>
            {isNewSkill ? (
              <SkillForm
                onCancel={() => setIsNewSkill(false)}
                onSuccess={(newSkill) => {
                  setIsNewSkill(false)
                  setSelectedSkillId(newSkill.skillId)
                }}
              />
            ) : selectedSkillId ? (
              <SkillVersionHistory
                skillId={selectedSkillId}
                onCancel={() => {
                  setSelectedSkillId(null)
                  setIsNewSkill(false)
                }}
              />
            ) : (
              <Box display='flex' alignItems='center' justifyContent='center' height='100%'>
                <Typography color='textSecondary'>Select a skill to view versions</Typography>
              </Box>
            )}
          </div>
        </div>
      </div>
    </AdminPage>
  )
}

DenaliAISkills.propTypes = {
  root: PropTypes.any // Passed from parent but not used in this component
}

export default DenaliAISkills
